'use client';

import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@pickleballinc/ui/components/ui/dialog';
import { useParams } from 'next/navigation';
import { toast } from 'react-toastify';

import { ApproveDeclineRequestForm } from '@/components/forms';
import { ApproveDeclineRequestData } from '@/entities';
import { useTeamLeagueInfo } from '@/hooks/custom-hooks/useTeamLeagueInfo';
import { useJoinRequest } from '@/hooks/hooks';
import { useOrganizationStore } from '@/store/organization-store';

interface ApproveDeclineRequestModalProps {
	open: boolean;
	onClose: () => void;
	transferRequestUuid: string;
	fullName: string;
	teamName: string;
}

export const ApproveDeclineRequestModal = ({ open, onClose, transferRequestUuid, fullName, teamName }: ApproveDeclineRequestModalProps) => {
	const store = useOrganizationStore();
	const params = useParams<{ teamId: string }>();
	const { seasonUuid } = useTeamLeagueInfo();
	const { mutateAsync: joinRequest, isPending } = useJoinRequest();

	const handleFormSubmit = async (data: ApproveDeclineRequestData) => {
		const action = data.approvePlayerRequest ? 'approve' : 'decline';
		try {
			await joinRequest({
				organizationId: store.organizationUuid,
				teamLeagueId: store.teamLeagueUuid,
				teamId: params.teamId,
				tradeRequestUuid: transferRequestUuid,
				action,
				seasonId: seasonUuid
			});
			onClose();
		} catch {
			toast.error('Something went wrong and we were unable to approve/decline player request.');
		}
	};

	return (
		<Dialog
			open={open}
			onOpenChange={(o) => {
				if (!o) onClose();
			}}
		>
			<DialogContent className="max-w-[340px] rounded-lg sm:max-w-[524px] gap-0 p-6" hideClose>
				<DialogHeader className="flex w-full items-end justify-between flex-row">
					<DialogTitle>Approve or Decline player request</DialogTitle>
					<FontAwesomeIcon icon={faTimes} size="lg" className="text-gray-500 cursor-pointer" onClick={onClose} />
				</DialogHeader>
				<ApproveDeclineRequestForm
					fullName={fullName}
					teamName={teamName}
					onSubmit={handleFormSubmit}
					onClose={onClose}
					isPending={isPending}
				/>
			</DialogContent>
		</Dialog>
	);
};
